import React, { StrictMode } from "react";
import ReactDOM from "react-dom";
import Portfolio from "./Portfolio";

import "./styles/main.scss";

ReactDOM.render(
    <StrictMode>
        <Portfolio />
    </StrictMode>,
    document.getElementById("root")
);
